import React, { useState, useEffect, useMemo } from "react";
import Videos from "../components/Videos";
import Articles from "../components/Articles";
import { getProgress, getResources } from "../Api";
import secureLocalStorage from "react-secure-storage";
import "../css/Modal.css";
import { Link } from "react-router-dom";
import { appVersion } from "../services/constants";

const Explore = () => {
  const [patientInfo, setPatientInfo] = useState(null);
  const [weekNo, setWeekNo] = useState(0);
  const [resources, setResources] = useState([]);
  const [articles, setArticles] = useState([]);
  const [surgeryStatus, setSurgeryStatus] = useState([null]);

  const getPatientId = () => {
    return secureLocalStorage.getItem("patient_id");
  };

  const fetchResources = async (week_no, isPreventive) => {
    try {
      const response = await getResources(week_no, "VIDEO", isPreventive);
      setResources(response);
    } catch (error) {
      console.error("Error fetching VIDEO:", error);
    }
  };

  const fetchArticles = async (week_no, isPreventive) => {
    try {
      const response = await getResources(week_no, "ARTICLE", isPreventive);
      setArticles(response);
    } catch (error) {
      console.error("Error fetching ARTICLE:", error);
    }
  };

  useEffect(() => {
    const fetchProgress = async () => {
      try {
        const response = await getProgress(getPatientId());
        secureLocalStorage.setItem("week_no", response.patient_info.week_no);
        secureLocalStorage.setItem("patient_info", response.patient_info);
        setWeekNo(response.patient_info.week_no);
        setPatientInfo(response.patient_info);
        fetchResources(response.patient_info.week_no, response.patient_info.is_preventive);
        fetchArticles(response.patient_info.week_no, response.patient_info.is_preventive);
      } catch (error) {
        console.error("Error fetching progress:", error);
      }
    };

    fetchProgress();
  }, []);

  const currentDate = useMemo(() => new Date(), []);

  const generateWeekAndStatus = useMemo(() => {
    const surgeryDate = new Date(patientInfo?.start_date);
    const weeksDiff = Math.abs(patientInfo?.week_no);

    let message = "";
    let typeStr = "";
    if (patientInfo?.is_preventive == 1) {
      message = `Week ${weeksDiff} of Prehab`;
      typeStr = "Prevention";
    }

    if (patientInfo?.is_preventive == 0) {
      if (surgeryDate > currentDate) {
        typeStr = "Pre-Op";
        message = `${weeksDiff} ${
          weeksDiff == 1 ? "Week" : "Weeks"
        } Until Your Big Day`;
      } else {
        typeStr = "Post-Op";
        message = `Week ${weeksDiff} of Your Recovery`;
      }
    }

    setSurgeryStatus(typeStr);

    return { message, typeStr };
  }, [patientInfo, currentDate]);

  return (
    <main className="main-content">
      <div className="main fade-med">
        <div className="headContents mb-20">
          <div className="headContent-left">
            <>
              <h2 className="heading">{generateWeekAndStatus.message}</h2>
              <p className="subHeading">
                <span>{generateWeekAndStatus.typeStr}</span> -{" "}
                {currentDate.toDateString()}
              </p>
            </>
          </div>
          <div className="headContent-right">
            <div className="streakContainer">
              <h4>Streak</h4>
              <p>1</p>
            </div>
            <div className="romContainer">
              <img
                className="headerContentSeparator"
                src="../headerContentSeparator.svg"
              />
              <h4>ROM Personal Best</h4>
              <p className="romBest">
                {patientInfo?.romGallery?.length > 0
                  ? Math.max(...patientInfo.romGallery.map((item) => item.rom_value))
                  : 0}
                °
              </p>
            </div>
          </div>
        </div>
        <Videos resources={resources} />
        <Articles resources={articles} />
        <Link to="/logout" className="logout-button app-version">
          <b>({appVersion})</b> Logout
        </Link>
      </div>
    </main>
  );
};

export default Explore;
